/**
 * Pure function to determine the appropriate toast message for Feedback completion.
 * Handles all terminal states: oversized, success, all-failed, all-filtered, no-comments, and fallback.
 *
 * @param {object} chunk - The SSE chunk from the backend containing feedbackComplete flags
 * @param {string|null} noCommentsMessage - The model's explicit "no comments needed" explanation
 * @returns {string} The toast message to display to the user
 */
export function getFeedbackToastMessage(chunk, noCommentsMessage) {
  if (chunk.oversizedDocument) {
    return chunk.oversizedMessage || "This document is too large for Feedback. Please split it into smaller chapters.";
  }
  if (chunk.totalComments > 0) {
    return `Feedback complete — ${chunk.totalComments} suggestion${chunk.totalComments === 1 ? "" : "s"} added`;
  }
  // A prior chunk may have emitted no_comments before a later chunk exhausted
  // generation. In that mixed state, prefer the terminal failure while keeping
  // any more specific placement/processing failure message.
  if (chunk.generationFailed && chunk.allCommentsFailed) {
    return "Feedback failed — comments could not be placed. Please try again.";
  }
  if (chunk.generationFailed && chunk.allSkippedOrFiltered) {
    return "Feedback failed — generated comments could not be processed. Please try again.";
  }
  if (chunk.generationFailed) {
    return "Feedback failed — unable to generate comments. Please try again.";
  }
  if (chunk.mostCommentsFailed) {
    return "Feedback failed — most comments could not be placed. No credits charged.";
  }
  if (noCommentsMessage) {
    return `Feedback complete — ${noCommentsMessage} No credits charged.`;
  }
  if (chunk.allCommentsFailed) {
    return "Feedback failed — comments could not be placed. Please try again.";
  }
  if (chunk.allSkippedOrFiltered) {
    return "Feedback failed — generated comments could not be processed. Please try again.";
  }
  return "Feedback complete — no changes needed. No credits charged. Nice work!";
}
